"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInjectedAuthProviderProps = exports.buildAuthProviderProps = void 0;
var clerk_react_1 = require("@clerk/clerk-react");
var react_1 = __importDefault(require("react"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var inversify_react_1 = require("inversify-react");
var AuthenticationContext_1 = require("Public/Identity/AuthenticationContext");
var buildAuthProviderProps = function (args) {
    var publishableKey = args.publishableKey, authenticationAppBaseUrl = args.authenticationAppBaseUrl;
    if (args.customDomainEnabled) {
        var currentHostname = args.currentHostname;
        var isSatellite = !currentHostname.endsWith(args.primaryHostname);
        var domain = currentHostname;
        var proxyUrl = isSatellite ? "https://".concat(currentHostname, "/__clerk") : undefined;
        if (args.environment === "production") {
            return {
                publishableKey: publishableKey,
                authenticationAppBaseUrl: authenticationAppBaseUrl,
                isSatellite: isSatellite,
                proxyUrl: proxyUrl,
            };
        }
        else {
            return {
                publishableKey: publishableKey,
                authenticationAppBaseUrl: authenticationAppBaseUrl,
                signInUrl: "".concat(args.authenticationAppBaseUrl, "/debug"),
                isSatellite: isSatellite,
                domain: domain,
            };
        }
    }
    else {
        return {
            publishableKey: publishableKey,
            authenticationAppBaseUrl: authenticationAppBaseUrl,
        };
    }
};
exports.buildAuthProviderProps = buildAuthProviderProps;
var useInjectedAuthProviderProps = function () {
    var environment = (0, inversify_react_1.useInjection)("environment");
    var primaryHostname = (0, inversify_react_1.useInjection)("hostname");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var authAppBaseUrl = (0, inversify_react_1.useInjection)("authAppBaseUrl");
    var publishableKey = (0, inversify_react_1.useInjection)("clerkPublishableKey");
    if (usingFeature(FeatureFlag_1.default.Domain) && usingFeature(FeatureFlag_1.default.RefreshedIdentityProtected)) {
        return (0, exports.buildAuthProviderProps)({
            customDomainEnabled: true,
            primaryHostname: primaryHostname,
            currentHostname: window.location.hostname,
            environment: environment,
            authenticationAppBaseUrl: authAppBaseUrl,
            publishableKey: publishableKey,
        });
    }
    else {
        return (0, exports.buildAuthProviderProps)({
            customDomainEnabled: false,
            publishableKey: publishableKey,
            authenticationAppBaseUrl: authAppBaseUrl,
        });
    }
};
exports.useInjectedAuthProviderProps = useInjectedAuthProviderProps;
var AuthenticationProvider = function (props) {
    var children = props.children, authenticationAppBaseUrl = props.authenticationAppBaseUrl, clerkProviderProps = __rest(props, ["children", "authenticationAppBaseUrl"]);
    return (react_1.default.createElement(clerk_react_1.ClerkProvider, __assign({}, clerkProviderProps),
        react_1.default.createElement(AuthenticationContext_1.AuthenticationContextProvider, { authAppBaseUrl: authenticationAppBaseUrl }, children)));
};
exports.default = AuthenticationProvider;
